import { render, staticRenderFns } from "./manageDetail.vue?vue&type=template&id=2a38902e&scoped=true"
import script from "./manageDetail.vue?vue&type=script&lang=js"
export * from "./manageDetail.vue?vue&type=script&lang=js"
import style0 from "./manageDetail.vue?vue&type=style&index=0&id=2a38902e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38902e",
  null
  
)

export default component.exports